import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { ModalIcon, ModalKeys, NotificationService } from '@shared/notification/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { PlatformLoginService } from 'app/services/platform-login/platform-login.service';
import { TimberService } from '@logging/timber.service';
import { Platform } from '@nodeModules/@itero/itero-platform-login';

@Injectable({ providedIn: 'root' })
export class PlatformAccessService {
	constructor(
		private readonly platformLoginService: PlatformLoginService,
		private readonly notificationService: NotificationService,
		private readonly translateService: TranslateService,
		private timberService: TimberService
	) {}

	async verifyOrRedirect(platform: Platform): Promise<boolean> {
		try{
			const canAccess = await this.platformLoginService.canUserAccessPlatform(platform);
			if (!canAccess) {
				this.notificationService.show(
					this.translateService.instant('ExpectedRoles.RolesWarningHeader'),
					this.translateService.instant('ExpectedRoles.RolesWarningMessage'),
					{ buttonCombination: ModalKeys.Ok, icon: ModalIcon.Info }
				).pipe(take(1)).subscribe(() => this.platformLoginService.navigateToNewLogin());
			}
			return canAccess;
		}catch(err) {
			this.timberService.error(`Error verifying access.`, { module: 'PlatformAccessService', error: err });
			return false;
		}
		
	}
}
